import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const { t } = useTranslation();

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: t('siteName'),
    url: window.location.origin,
    description: t('siteDescription'),
    contactPoint: {
      '@type': 'ContactPoint',
      email: t('footer.email'),
      contactType: 'customer service',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <footer className="bg-secondary-50 border-t border-secondary-200">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-lg">
                  <i className="ri-plug-line"></i>
                </span>
                <span className="text-lg font-bold text-foreground-950 font-heading">
                  {t('siteName')}
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t('footer.brandIntro')}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-900 mb-4 font-heading">
                {t('footer.quickLinks')}
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                    {t('nav.home')}
                  </Link>
                </li>
                <li>
                  <Link to="/category/caozuo-fangfa" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                    {t('nav.categories')}
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200">
                    {t('nav.about')}
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-900 mb-4 font-heading">
                {t('footer.categories')}
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-900 mb-4 font-heading">
                {t('footer.contactUs')}
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-mail-line text-primary-500"></i>
                  <a href="mailto:contact@bachabacha.com" className="hover:text-primary-500 transition-colors duration-200">
                    {t('footer.email')}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-secondary-200 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-400">
              <Link to="/" className="hover:text-primary-500 transition-colors duration-200">首页</Link>
              <Link to="/about" className="hover:text-primary-500 transition-colors duration-200">关于我们</Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}